import './analytics/connector';
import './analytics/events/tracker';
import AnalyticsEventRouter from './analytics/events/router';
import { IDataLayer } from './types';

// TODO: get rid of this, currently present for legacy support as Tealium uses this to communicate via events
import ElcDispatcher from './analytics/elc_dispatcher';

export const startAnalytics = (
  settings: IDataLayer,
  pageData: IDataLayer = {},
) => {
  window.site = window.site || {};
  window.site.elcEvents = new ElcDispatcher();

  //initialize analytics event router
  new AnalyticsEventRouter();

  if (!window?.tealium?.loaded) {
    window.tealium.init(
      {
        tealiumProfile: settings.analytics?.profile,
        tealiumUrl: settings.analytics?.url,
        tealiumEnv: settings.analytics?.env,
      },
      pageData,
    );
  }
};
